export const StatusListOptions = [
    {
        label: 'unpublished',
        value: 'unpublished',
    },
    {
        label: 'beta',
        value: 'beta',
    },
    {
        label: 'published',
        value: 'published',
    },
];
export var AvailableFor;
(function (AvailableFor) {
    AvailableFor["FREE"] = "FREE";
    AvailableFor["PRO_CLINIC"] = "PRO_CLINIC";
})(AvailableFor || (AvailableFor = {}));
export const AvailableForListOptions = [
    {
        label: 'Free',
        value: AvailableFor.FREE,
    },
    {
        label: 'Pro/Clinic',
        value: AvailableFor.PRO_CLINIC,
    },
];
export const TariffListOptions = [
    {
        label: 'Free',
        value: 'FREE',
    },
    {
        label: 'Per minute',
        value: 'PER_MINUTE',
    },
    {
        label: 'Per hour',
        value: 'PER_HOUR',
    },
    {
        label: 'Per month',
        value: 'MONTHLY',
    },
];
export var TYPES;
(function (TYPES) {
    TYPES["EXTENSION"] = "extension";
    TYPES["EXTERNAL_TOOL"] = "external_tool";
    TYPES["INFO"] = "info";
})(TYPES || (TYPES = {}));
export const templateExtension = {
    id: null,
    icon: null,
    name: null,
    title: null,
    source: null,
    sourceCode: null,
    description: null,
    shortDescription: null,
    optionalDescription: null,
    status: 'unpublished',
    video: null,
    isFake: false,
    price: null,
    createdAt: null,
    termsUrl: null,
    email: null,
    tariff: 'FREE',
    hint: null,
    isDeleted: false,
    type: TYPES.EXTENSION,
    availableFor: AvailableFor.FREE,
};
